import React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '../SvgIcon';

const RemoveIcon = ({ height, viewBox, width, ...rest }) => {
    return (
        <SvgIcon width={width} height={height} viewBox={viewBox} {...rest}>
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.50033 2.18184C4.73475 2.18184 1.68214 5.23444 1.68214 9.00002C1.68214 12.7656 4.73475 15.8182 8.50033 15.8182C12.2659 15.8182 15.3185 12.7656 15.3185 9.00002C15.3185 5.23444 12.2659 2.18184 8.50033 2.18184ZM0.166992 9.00002C0.166992 4.39765 3.89795 0.666687 8.50033 0.666687C13.1027 0.666687 16.8337 4.39765 16.8337 9.00002C16.8337 13.6024 13.1027 17.3334 8.50033 17.3334C3.89795 17.3334 0.166992 13.6024 0.166992 9.00002Z"
                    fill="#B53349"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.3087 6.19161C11.6046 6.48746 11.6046 6.96713 11.3087 7.26298L6.76329 11.8084C6.46743 12.1043 5.98776 12.1043 5.69191 11.8084C5.39606 11.5126 5.39606 11.0329 5.69191 10.7371L10.2374 6.19161C10.5332 5.89575 11.0129 5.89575 11.3087 6.19161Z"
                    fill="#B53349"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.69191 6.19161C5.98776 5.89575 6.46743 5.89575 6.76329 6.19161L11.3087 10.7371C11.6046 11.0329 11.6046 11.5126 11.3087 11.8084C11.0129 12.1043 10.5332 12.1043 10.2374 11.8084L5.69191 7.26298C5.39606 6.96713 5.39606 6.48746 5.69191 6.19161Z"
                    fill="#B53349"
                />
            </svg>
        </SvgIcon>
    );
};

RemoveIcon.propTypes = {
    height: PropTypes.string,
    viewBox: PropTypes.string,
    width: PropTypes.string,
};

RemoveIcon.defaultProps = {
    height: '16',
    viewBox: '17 17',
    width: '16',
};

export default RemoveIcon;
